import axios, { type AxiosInstance } from 'axios';

import { getCsrfToken } from '@ctct/ctct-helpers';

import { applyCustomErrorInterceptor } from './applyCustomErrorInterceptor';
import { fetchCsrfToken } from './fetchCsrfToken';
import { envs } from '../Environments';

export class AxiosClient {
  private client: AxiosInstance | null = null;

  constructor(private baseURL: string, private defaultHeaders: Record<string, string> = {}) {}

  public async getClient() {
    let token = getCsrfToken();

    if (envs.isSecure()) {
      token = await fetchCsrfToken();
    }

    if (!this.client) {
      this.client = axios.create({
        baseURL: this.baseURL,
        headers: {
          'X-CSRF-Token': token,
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/json',
          'Cache-Control': 'no-store',
          ...this.defaultHeaders,
        },
        withCredentials: true,
        withXSRFToken: true,
      });

      applyCustomErrorInterceptor(this.client);

      this.client.interceptors.response.use(
        (response) => response,
        (error) => {
          if (error.response?.status === 401) {
            window.location.href = `https://login${envs.getEnv()}constantcontact.com/login/login.sdo?goto=${encodeURIComponent(
              window.location.href
            )}`;
          }

          return Promise.reject(error);
        }
      );
    }

    return this.client;
  }
}
